import { serverFetch } from "@core/server";

export function fetchSprStatusList() {
  return serverFetch("sprs/status");
}

export function fetchSprStatus(idStatus) {
  return serverFetch(`sprs/status/${idStatus}`);
}

export function createSprStatus(bodyData) {
  return serverFetch("sprs/status", {
    method: "POST",
    bodyData
  });
}

export function saveSprStatus(bodyData) {
  return serverFetch("sprs/status", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprStatus(idStatus) {
  return serverFetch(`sprs/status/${idStatus}`, {
    method: "DELETE"
  });
}
